module.exports = __webpack_public_path__ + "assets/img/page2-design-side-nav-expanded-1-66f8a7e7.png";